export default {
  title: {
    thirdIntegrationConfigManagementTitle: 'Third Integration Config Management'
  },
  label: {
    aiInterviewConfigTitle: 'AI Interview Config',
    aiInterviewServiceProvider: 'AI Interview Service Provider',
    appKey: 'APP Key',
    appSecret: 'APP Secret',
    appSalt: 'Salt',
    appUniqueCode: 'Unique Code',
    appId: 'APP ID',
    appToken: 'Token',
    appCode: 'Code',
    serverUrl: 'Server Url',
    appMsgSecret: 'Message Secret',
    aiInterviewCallbackUrl: 'Callback Url'
  },
  SERVICE_PROVIDER: {
    DUO_MIAN: 'Duo Mian AI',
    HRTPS: 'HRTPS'
  }
}
